export enum LangType {
    zh = 'zh',
    en = 'en',
    zh_tw = 'zh_tw'
}
export type InputTextValue = {
    [key in LangType]: string
}

//节点数据类型
export enum VirtualDomNode {
    object = 'object',
    array = 'array',
    string = 'string',
    number = 'number',
    boolean = 'boolean',
    null = 'null',
    undefined = 'undefined'
}

//下拉框
export enum VirtualArrayKey {
    /**
     * 值输入
     */
    inputIndex = 'inputIndex',
    /**
     * 值变量
     */
    variateIndex = 'variateIndex'
}

//虚拟节点

export interface VirtualDomItem {
    label: InputTextValue,
    key: string,
    value: string | number | boolean | null | undefined,
    isSelected: boolean,
    arrayKey?: VirtualArrayKey,
    arrayValue?: any
}
export interface VirtualDomItemType extends Partial<VirtualDomItem> {
    uuid: string,
    type: VirtualDomNode,
    children: VirtualDomItemType[]
}

//组件传参
export interface JsonNodeProps {
    node: VirtualDomItemType | null,
    selectedUuid: string | "",
    onSelect: (targetUuid: string, isChecked: boolean) => void,
    onChangeArrKey:(targetUuid: string, value: VirtualArrayKey) => void,     //修改数组key
}

export interface JsonViewerProps {
    rootNode: VirtualDomItemType | null,
    expression: string,
    selectedUuid: string | "",
    onSelect: (targetUuid: string, isChecked: boolean) => void,     //选中叶子节点
    onChangeArrKey:(targetUuid: string, value: VirtualArrayKey) => void,     //修改数组key
}

export interface ExpressionProps {
    expression: string,
}

